export const excelJson = {
    "payload": {
        "validItems": [
            {
                "receiver": {
                    "firstName": "شقایق",
                    "lastName": "حسینی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2301",
                    "address": "بزرگراه ستاری، خ پیامبر مرکزی، خ هجرت، کوچه اوردی خانی پلاک 2 واحد 6",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "d6112963-08d3-426e-9c90-83e958dbfd53"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "کامران",
                    "lastName": "رحمانی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2301",
                    "address": "کارگر شمالی خ چهارم لاین کندرو تقاطع صالحی پ2 ط4  پلاک  واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "مازیار",
                    "lastName": "فلاحی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2301",
                    "address": "شهرک اکباتان فاز2 بلوک2 ورودی1 طبقه اول پ 27 پلاک 27 واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "یاسر",
                    "lastName": "ولی زاد",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0603",
                    "address": "اندیمشک-اندیمشک خیابان امام پاساژ جوانان موبایل یاسر  پلاک  واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "فاطمه",
                    "lastName": "خرقانی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2309",
                    "address": "شهریار-شهریار شهرک وایین خیابان جویبار کوچه رحمانی پلاک 12 واحد 1 پلاک  واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "عباس",
                    "lastName": "ارام",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0603",
                    "address": "کوی ملت خیابان 5 اقبال پلاک 1 ویلایی  پلاک 1 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "حامد",
                    "lastName": "بمانی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0303",
                    "address": "مراغه-مراغه کمربندی شرقی کوی متین آپارتمان مهستان طبقه ی 5 واحد 12 پلاک  واحد 12",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "عبدالرزاق",
                    "lastName": "یوسفیان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1105",
                    "address": "ایرانشهر-بلوار مکران- اداره صنعت،معدن و تجارت شهرستان ایرانشهر - واحد صنعت و معدن پلاک  واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "صدیقه",
                    "lastName": "رهنمایی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2301",
                    "address": "نارمک،خیابان سمنگان ،خیابان ارشی،خیابان اسمیپلاک 250 واحد4 پلاک  واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "فاطمه",
                    "lastName": "رضائیان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0707",
                    "address": "بلوار همت جنوبی خیابان شهید شیخی مجتمع مسکونی فجر بلوک 14واحد 6 پلاک 6 واحد 14",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "احمد",
                    "lastName": "امیر",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1105",
                    "address": "قصرقند-شهرستان قصرقند-محله رحمانشهر  پلاک 0 واحد 0",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "آسیه",
                    "lastName": "دهقان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1801",
                    "address": "بهمنی. میدان خواجه ها روبه روی مینی پارک کودک ساختمان سینا طبقه اول واحد 1  پلاک  واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "روزبه",
                    "lastName": "رئوف",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0603",
                    "address": "فرهنگ شهر منازل گروه ملی گلها دو  پلاک 14 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "رضا",
                    "lastName": "چوبین",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2705",
                    "address": "گلستان-گنبدکاووس-خیابان شهید فلاحی کوچه9 دومین فرعی سمت چپ وسط کوچه پلاک 36 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "امین",
                    "lastName": "عمرانی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0207",
                    "address": "کوی ازادی ازادی 2 سومین ساختمان سمت چپ منزل بهرامپور پلاک 1 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "حسین",
                    "lastName": "مقدم",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0401",
                    "address": "زمینهای جهاد و برق کوچه شماره 16 بدیعی بن بست شماره5شهیدفرهادبدیعی انتهای کوچه ساختمان آوا پلاک 179 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "سیدحسین",
                    "lastName": "صدر",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1002",
                    "address": "گزبرخوار-بلوار شهدا کوی گل افشان  پلاک 27 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "سمیه",
                    "lastName": "رضازادگان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0707",
                    "address": "خیابان گلچین غربی کوچه 20 بعد از فرعی 20٫2 درب اول طبقه 2 پلاک 0 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "محرم",
                    "lastName": "برکادهی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2309",
                    "address": "شهریار-شهرک کاروان.خیابان حافظ غربی .نسترن ششم  پلاک 93 واحد 3",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "مهرداد",
                    "lastName": "طرقبه",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0916",
                    "address": "طرقبه-خیابان طرقدر ، طرقدر 18  پلاک پلاک 194 واحد زنگ 3",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "سلمان",
                    "lastName": "گوزل پوریان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0303",
                    "address": "سیلاب ملازینال جنب مدرسه حضرت رقیه  پلاک 11/2 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "مهلا",
                    "lastName": "حسنی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2202",
                    "address": "قشم-شهرک نریمان خیابان یاس شرقی پلاک 10 واحد 3",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "علی",
                    "lastName": "نهرین",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "3001",
                    "address": "مهرشهر بلوار ارم خیابان 20متری قربانی مجتمع صدف پلاک بلوک26 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "رضا",
                    "lastName": "زمانی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "3001",
                    "address": "کمال شهر-کمالشهر بلور شهرداری بوستان هشتم انتهای کوچه ساختمان جام جم پلاک 7 واحد 18",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "زهرا",
                    "lastName": "کرم اله",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1503",
                    "address": "دلفان-کوی پاسداران کوچه پاسداران 8 پلاک 17 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "بهناز",
                    "lastName": "صالح",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2301",
                    "address": "جوادیه بیست متری کوچه حاتمی  پلاک 20 واحد 8",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "زهراالسادات",
                    "lastName": "غیاثیان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2310",
                    "address": "اسلامشهر-شهرک انبیا خیابان رجایی کوچه فردوس 19 پلاک 933 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "مسعود",
                    "lastName": "محمدیان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2603",
                    "address": "قزوین.شهرک مینودر.میدان حافظ.پارک سنگی. خ سلمان.کوچه نهضت پلاک19 واحد2 پلاک 19 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "ساتیار",
                    "lastName": "لطفیان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1204",
                    "address": "سقز-بهارستان پایین خیابان رضوان  پلاک 23 واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "هما",
                    "lastName": "کمندلو",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0001",
                    "address": "گردو.خیابان حافظ.نیلوفر دوم.لادن پنجم پلاک 15 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "ایوب",
                    "lastName": "کریمیان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1204",
                    "address": "سقز-کردستان سقز بلوار انقلاب کوچه محمد اوراز روبروی سالن ورزشی حجاب پلاک 27 پلاک 27 واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "میریوسف",
                    "lastName": "اساییان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0303",
                    "address": "مرند-خیابان شهیدرجایی کوچه اسلام آباد کوی لاله غربی پلاک 38 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "محسن",
                    "lastName": "عبدی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2901",
                    "address": "طبس-بلوار شهید رجایی بالاتر از مسجدالرسول بریدگی اول درب هخامنشی پلاک  واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "لیلا",
                    "lastName": "اسدی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1304",
                    "address": "ملایر-ملایر خ تختی کوچه شعبانی  ساختمان کاج واحد 2  زنگ 2 پلاک 264 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "سبحان",
                    "lastName": "بیدخانی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1801",
                    "address": "خیابان یادگار امام، کوی نصر، کوچه نصر 11، انتهای کوچه ساختمان یلدا طبقه دوم پلاک  واحد 5",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            }
        ],
        "invalidItems": [
            {
                "receiver": {
                    "firstName": "",
                    "lastName": "معنویان",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0916",
                    "address": "تربت جام-خیابان المهدی رو بهروی دوربرگردان حامی همراه پلاک 249 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "امین",
                    "lastName": "خوراسگانی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "1002",
                    "address": "",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "رسول",
                    "lastName": "",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0105",
                    "address": "پره سر-پره‌سر-اداره پست پلاک 18 واحد",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "معصومه",
                    "lastName": "عافیت",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": null,
                    "address": "ری-حمزه آباد خ محمودی جنب مسجد موسی بن جعفر پلاک 100 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "عرفان",
                    "lastName": "وفا",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2501",
                    "address": "قم .بنیاد خیابان شهید مطهری کوچه 2 طبقه دوم پلاک 2 واحد طبقه دوم",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "",
                    "lastName": "علیانی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0502",
                    "address": "اسلام ابادغرب-میدان هدایت بلوار معلم کوچه شهید هدایت مرادی  پلاک 16 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "ایمان",
                    "lastName": "اشتریان",
                    "nationalCode": "",
                    "phone": "",
                    "cityCode": null,
                    "address": "امل-کمانگر کلا هراز پی لاله 22  پلاک 407 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "کوثر",
                    "lastName": "لشکری ابادی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": null,
                    "address": "بلوار جمهوری روبروی بلوار‌حمزه بانک پاسارگاد  پلاک 1 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "نساء",
                    "lastName": "نوشاد",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2202",
                    "address": "کیش-کیش فجر ششم  پلاک 129 واحد 4",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": null
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "فاطمه",
                    "lastName": "هاشمی",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": null,
                    "address": "مرند-خیابان شهیدرجایی کوچه اسلام آباد کوی لاله غربی  پلاک 38 واحد 1",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "سیما",
                    "lastName": "ملک",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2321",
                    "address": "قرچک-خیابان اصلی ابتدای خیابان خلیج فارس جنب باطری سازی جعفر ساختمان گل سرخ واحد7 پلاک  واحد 7",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "هادی",
                    "lastName": "",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "2301",
                    "address": "شهرک مسعودیه خیابان ابومسلم خراسانی کوچه مردانی پلاک 18 واحد 2",
                    "postalCode": "1111111111"
                },
                "parcels": [
                    {
                        "content": "",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            },
            {
                "receiver": {
                    "firstName": "میلاد",
                    "lastName": "قلیزاد",
                    "nationalCode": "",
                    "phone": "09121111111",
                    "cityCode": "0916",
                    "address": "بولوارهاشمیه79 پلاک 3 واحد 4",
                    "postalCode": ""
                },
                "parcels": [
                    {
                        "content": "کارت",
                        "weight": {
                            "value": "200",
                            "unit": "G"
                        },
                        "value": {
                            "amount": "10000",
                            "currency": "IRT"
                        },
                        "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                    }
                ],
                "description": ""
            }
        ]
    },
    "message": "Successful"
}
export const bulkJson = {
    "payload": [],
    "message": "Successful"
}